<script>
  import { SPRITESHEET_URL } from '../../utils/constants';
  import { openOverpanel } from '../../stores/overpanelControl';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import DrugSearch from '../DrugSearch/DrugSearch.svelte';
  import BaseLink from '../BaseLink/BaseLink.svelte';

  let {
    headingTextTemplate,
    headingLevel = 'h2',
    contentTemplate,
    searchInputPlaceholder,
    drugSearch,
    drugs,
    columns = 3,
    small = false,
    comparePricesButtonText,
    dataTestId = 'drug-savings-list',
    lang,
  } = $props();
</script>

{#if drugs && drugs.length}
  <div data-testid={dataTestId}>
    {#if drugSearch}
      <BaseHeading
        {headingLevel}
        className="grow text-blue-dark-navy text-lg md:text-xl lg:text-2xl leading-tight font-semibold mb-2 lg:mb-4"
      >
        {headingTextTemplate}
      </BaseHeading>
      <div class="max-w-xl md:max-w-2xl -mx-3">
        <DrugSearch {...drugSearch} {lang} parentComponent='drugSavingsList' />
      </div>
    {:else}
      <button
        class="w-full flex items-center sm:pb-3 text-blue-cerulean group mb-4"
        class:pb-3={!searchInputPlaceholder}
        class:border-b={!searchInputPlaceholder}
        class:border-gray-light-silver={!searchInputPlaceholder}
        class:sm:border-b={contentTemplate}
        class:sm:border-gray-light-silver={contentTemplate}
        onclick={() => {
          window.umami.track('drugSavingsList-compare-prices-click');
          openOverpanel('search');
        }}
      >
        <BaseHeading
          {headingLevel}
          className="text-left grow text-blue-dark-navy text-lg md:text-xl lg:text-2xl leading-tight font-semibold"
        >
          {headingTextTemplate}
        </BaseHeading>
        <span
          class="hidden sm:block text-sm font-semibold hover-hover:group-hover:text-blue-dark-navy hover-hover:group-hover:underline"
          >{comparePricesButtonText}</span
        >
        <svg
          class="hidden sm:block w-4 h-4 fill-current ml-2 hover-hover:group-hover:text-blue-dark-navy active:text-blue-dark-navy"
          class:hidden={searchInputPlaceholder}
          role="presentation"
        >
          <use xlink:href="{SPRITESHEET_URL}#right-arrow" />
        </svg>
      </button>

      {#if searchInputPlaceholder}
        <div class="relative w-full text-gray-gunmetal mb-4 sm:hidden">
          <svg class="absolute top-4 left-4 w-4 h-4 fill-current" role="presentation">
            <use xlink:href="{SPRITESHEET_URL}#magnifying-glass" />
          </svg>
          <button
            class="w-full min-h-12 rounded border border-gray-gunmetal bg-white py-2 pl-10 pr-4 leading-loose
              text-base text-gray-warm font-normal text-left placeholder-gray-warm cursor-text whitespace-nowrap
              overflow-hidden md:flex-2"
            aria-label={comparePricesButtonText}
            onclick={() => openOverpanel('search')}
          >
            {searchInputPlaceholder}
          </button>
        </div>
      {/if}
    {/if}
    {#if contentTemplate}
      <div class="md:my-2 lg:max-w-4xl" class:lg:text-lg={!small}>
        {@html contentTemplate}
      </div>
    {/if}

    <div class="py-4 grid gap-4 sm:grid-cols-2 lg:gap-6" class:lg:grid-cols-3={columns === 3}>
      {#each drugs as { drugLink, slug, savingsCardLink, name, price, form, strength, quantity }, index (index)}
        {#if savingsCardLink}
          <div
            class="bg-white rounded-lg shadow-y-sm flex flex-col overflow-hidden"
            class:sm:hidden={index === 2}
            class:lg:flex={index === 2}
          >
            <div class="p-4 grow" data-testid="{dataTestId}-tile">
              <div class="flex justify-between">
                <h3
                  class="lg:mb-1 font-semibold text-base leading-tight text-blue-navy hover-hover:hover:text-blue-cerulean hover-hover:hover:underline"
                  class:lg:text-lg={!small}
                >
                  <BaseLink 
                    url={drugLink} 
                    text={name}
                    onClick={() => window.umami.track('drugSavingsList-drug-link-click', { drug: slug })}
                  />
                </h3>
                <span
                  class="whitespace-nowrap order-1 text-right text-xl -mt-1 font-semibold text-blue-cerulean"
                  class:lg:text-2xl={!small}
                >
                  {#if price && !isNaN(price.replace(',', ''))}
                    <sup class="text-xs -top-2">$</sup>
                    {price}
                  {/if}
                </span>
              </div>
              {#if quantity && strength && quantity}
                <div class="order-1 col-span-3 text-sm text-gray-charcoal">
                  <div>{form}, {strength}</div>
                  <div>{quantity}</div>
                </div>
              {/if}
            </div>
            <button
              onclick={() => {
                window.umami.track('drugSavingsList-savings-card-link-click', { drug: slug })
                window.location.href = savingsCardLink.url;
              }}
              class="w-full bg-blue-robin-egg flex justify-between items-center pl-4 pr-3 py-2 order-3 col-span-3 font-semibold text-blue-dark-navy
                text-left text-0.5sm sm:text-sm lg:text-0.5sm hover-hover:hover:text-blue-dark-navy hover-hover:hover:underline hover-hover:hover:bg-blue-light
                active:bg-blue-lightactive:text-blue-dark-navy group"
            >
              {savingsCardLink.text}
              <svg
                class="ml-2 min-w-4 h-4 w-4 fill-current text-blue-cerulean a11y-no-transform block duration-75 transition-transform ease-in
                 hover-hover:group-hover:scale-125 group-active:scale-125"
                role="presentation"
              >
                <use xlink:href="{SPRITESHEET_URL}#chevron-right" />
              </svg>
            </button>
          </div>
        {/if}
      {/each}
    </div>
  </div>
{/if}
